import { Infer, instance, number, object, string, union } from "superstruct";

export const TikTokGalleryWidgetConfigSchema = object({
    galleryId: number(),
    target: union([string(), instance(HTMLElement)]),
});

export const TikTokGalleryWidgetConfigToken = Symbol(
    "TikTokGalleryWidgetConfigToken"
);

export type TikTokGalleryWidgetConfigInterface = Infer<
    typeof TikTokGalleryWidgetConfigSchema
>;
